import { Box, Table, Link, Badge } from '@radix-ui/themes';
import { formatDateStr } from '../../utils/DateUtil';
import { getAdminBlogRequestAddress, getBlogRequestAddress } from '../../utils/PageAddressUtil';

export default function BlogRequestsTable({ requests, adminPage }) {
    return (
        <div className="redesign-table-wrap" id="blog-requests">
            <Table.Root variant="surface">
                <Table.Header>
                    <Table.Row>
                        <Table.ColumnHeaderCell>博客名称</Table.ColumnHeaderCell>
                        <Table.ColumnHeaderCell>博主邮箱</Table.ColumnHeaderCell>
                        <Table.ColumnHeaderCell>提交时间</Table.ColumnHeaderCell>
                        {adminPage ? <Table.ColumnHeaderCell>自行提交</Table.ColumnHeaderCell> : ''}
                        <Table.ColumnHeaderCell>审核状态</Table.ColumnHeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {requests.map((request, index) => (
                        <Table.Row key={index}>
                            <Table.RowHeaderCell>
                                <Link
                                    weight="bold"
                                    href={adminPage ? getAdminBlogRequestAddress(request.id) : getBlogRequestAddress(request.id)}
                                >
                                    {request.name}
                                </Link>
                            </Table.RowHeaderCell>
                            <Table.Cell>{request.adminEmail}</Table.Cell>
                            <Table.Cell>{formatDateStr(request.requestedAt, true)}</Table.Cell>
                            {adminPage ? <Table.Cell>{request.selfSubmitted ? '是' : '否'}</Table.Cell> : ''}
                            <Table.Cell>
                                <Badge
                                    size="2"
                                    className={request.approved ? 'redesign-badge-pass' : ''}
                                    color={request.approved ? 'green' : (request.failed ? 'crimson' : 'orange')}
                                >
                                    {request.statusInfo}
                                </Badge>
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table.Root>
        </div>
    );
}
